/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import {
  MenuItem,
  FormControl,
  styled,
  Select,
  InputLabel,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import React from "react";

const DropdownMUI = styled(Select)({
  // label on focus
  "div.MuiFormControl-root label.demo-multiple-name-label": {
    color: "black",
    fontWeight: 700,
    fontSize: "14px",
  },
  // Input Text Styles //
  "& .MuiInputBase-root": {
    color: "#171717",
    fontWeight: 500,
    fontSize: 14,
    borderRadius: 8,
  },
  "lebel.MuiFormLabel-root": {
    color: "black",
    fontSize: 14,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    "-webkit-text-fill-color": "rgba(0, 0, 0, 0.7)",
    backgroundColor: "rgba(239, 239, 239, 1.5)",
    borderRadius: 8,
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.7)",
  },
  "& .MuiSelect-icon.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.7)",
  },
});

const getId = (string) => (string ? string.replace(/ /g, "-") : "");

export default function Dropdown({
  value = "",
  options,
  containerStyle,
  label,
  onChange,
  handleClearValue,
  showCross = false,
  size = "small",
  disabled = false,
  required = false,
  ...props
}) {
  return (
    <FormControl sx={{ width: "100%", ...containerStyle }} size={size}>
      <InputLabel id={`dropdwon-${getId(label)}`}>
        {label}
        {required && <span style={{ color: "red" }}> *</span>}
      </InputLabel>
      <DropdownMUI
        style={{ borderRadius: 8, fontSize: 14 }}
        labelId={`dropdwon-${getId(label)}`}
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        required={required}
        // inputProps={{ required: true }}
        endAdornment={
          showCross ? (
            <IconButton
              sx={{
                visibility: value ? "visible" : "hidden",
                position: "absolute",
                right: "20px",
              }}
              onClick={handleClearValue}
            >
              <ClearIcon />
            </IconButton>
          ) : null
        }
        {...props}
        // displayEmpty
        // inputProps={{ "aria-label": "Without label" }}
      >
        {options?.map((option) => {
          return <MenuItem value={option.value}>{option.key}</MenuItem>;
        })}
      </DropdownMUI>
    </FormControl>
  );
}
